import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutYSplitStopsTable extends Layout {
    sourceStop: DataSource;
    tableOrderStops: Table;
}
